module.exports = __webpack_public_path__ + "img/add-square-icon.d77f1662.svg";